/** Static sample data for the public demo dashboard only — no API or auth. */

export const DUMMY_REVENUE = 184_250.75;

export const DUMMY_LIVE_PROJECTS = [
  {
    uid: "demo-live-1",
    title: "The Last Train Home",
    distributionStatus: "live",
    rating: 7.8,
    photo_url:
      "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=800&q=80",
  },
  {
    uid: "demo-live-2",
    title: "Monsoon Letters",
    distributionStatus: "live",
    rating: 7.2,
    photo_url:
      "https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=800&q=80",
  },
];

export const DUMMY_ELIGIBLE_PROJECTS = [
  {
    uid: "demo-eligible-1",
    title: "Streetlight Sonata",
    distributionStatus: "contract-filled",
    rating: 6.8,
    photo_url:
      "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=800&q=80",
  },
];

/** Full-page demo for live projects only (`/demo/project/:id`). */
export const DEMO_LIVE_PAGE_BY_ID = {
  "demo-live-1": {
    project: {
      uid: "demo-live-1",
      title: "The Last Train Home",
      distributionStatus: "live",
      rating: 7.8,
      photo_url:
        "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=800&q=80",
    },
    distribution: {
      title: "The Last Train Home",
      status: "live",
      project_id: "demo-live-1",
      platform: [
        {
          id: "demo-ott-a",
          status: "live",
          link: "https://example.com/demo/stream-east-watch",
          display_name: "StreamEast India",
          chart_color: "#10b981",
          exclusive: false,
          rev_share: true,
          value_text: "65",
          mode: "SVOD",
          period_years: 3,
          payout: "quarterly",
          metric_label: "Streaming views",
        },
        {
          id: "demo-ott-b",
          status: "live",
          link: "https://example.com/demo/fictionflix-watch",
          display_name: "FictionFlix",
          chart_color: "#3b82f6",
          exclusive: true,
          rev_share: true,
          value_text: "70",
          mode: "AVOD + SVOD",
          period_years: 2,
          payout: "monthly",
          metric_label: "Ad + subscription revenue",
        },
      ],
    },
    chart: {
      labels: [
        "August 2025",
        "September 2025",
        "October 2025",
        "November 2025",
        "December 2025",
        "January 2026",
        "February 2026",
        "March 2026",
      ],
      platforms: [
        {
          id: "demo-ott-a",
          title: "StreamEast India",
          color: "#10b981",
          // Launch spike (Aug) then decline every month — same shape as FictionFlix below
          views: [50000, 38000, 28500, 21500, 16200, 12200, 9200, 7000],
          users: [40000, 30400, 22800, 17200, 12960, 9760, 7360, 5600],
          timeMin: [62000, 47000, 35200, 26600, 20000, 15100, 11400, 8600],
          revenue: [35000, 26500, 19800, 14900, 11200, 8500, 6400, 4800],
        },
        {
          id: "demo-ott-b",
          title: "FictionFlix",
          color: "#3b82f6",
          // Same decay trend, slightly lower scale (typical second-window platform)
          views: [39000, 29600, 22200, 16800, 12600, 9500, 7200, 5450],
          users: [31200, 23700, 17800, 13400, 10100, 7600, 5760, 4360],
          timeMin: [48300, 36700, 27500, 20700, 15600, 11800, 8900, 6700],
          revenue: [27300, 20700, 15400, 11600, 8740, 6600, 5000, 3750],
        },
      ],
    },
  },
  "demo-live-2": {
    project: {
      uid: "demo-live-2",
      title: "Monsoon Letters",
      distributionStatus: "live",
      rating: 7.2,
      photo_url:
        "https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=800&q=80",
    },
    distribution: {
      title: "Monsoon Letters",
      status: "live",
      project_id: "demo-live-2",
      platform: [
        {
          id: "demo-ott-a",
          status: "live",
          link: "https://example.com/demo/stream-east-letters",
          display_name: "StreamEast India",
          chart_color: "#10b981",
          exclusive: false,
          rev_share: true,
          value_text: "65",
          mode: "SVOD",
          period_years: 3,
          payout: "quarterly",
          metric_label: "Streaming views",
        },
        {
          id: "demo-linear-1",
          status: "live",
          link: "https://example.com/demo/metro-tv-letters",
          display_name: "Metro Movies TV",
          chart_color: "#a855f7",
          exclusive: false,
          rev_share: true,
          value_text: "50",
          mode: "Linear + catch-up",
          period_years: 2,
          payout: "quarterly",
          metric_label: "Broadcast + VOD",
        },
      ],
    },
    chart: {
      labels: [
        "August 2025",
        "September 2025",
        "October 2025",
        "November 2025",
        "December 2025",
        "January 2026",
        "February 2026",
        "March 2026",
      ],
      platforms: [
        {
          id: "demo-ott-a",
          title: "StreamEast India",
          color: "#10b981",
          views: [45000, 34000, 25600, 19300, 14600, 11000, 8300, 6300],
          users: [36000, 27200, 20500, 15400, 11700, 8800, 6640, 5040],
          timeMin: [55800, 42200, 31700, 24000, 18100, 13600, 10300, 7800],
          revenue: [31500, 23800, 17900, 13500, 10200, 7700, 5800, 4400],
        },
        {
          id: "demo-linear-1",
          title: "Metro Movies TV",
          color: "#a855f7",
          // Same launch-then-decay pattern as OTT; linear starts a bit higher, slopes down in step
          views: [58000, 44000, 33200, 25000, 18900, 14200, 10700, 8100],
          users: [46400, 35200, 26560, 20000, 15120, 11360, 8560, 6480],
          timeMin: [72000, 54500, 41000, 31000, 23400, 17600, 13300, 10100],
          revenue: [40500, 30700, 23100, 17400, 13100, 9900, 7500, 5650],
        },
      ],
    },
  },
};

export function getDemoLiveProjectPage(id) {
  return DEMO_LIVE_PAGE_BY_ID[id] || null;
}

/** Rows shaped like aggregated payout API rows for the payouts table. */
export const DUMMY_PAYOUT_ROWS = [
  {
    project_id: "demo-live-1",
    project_title: "The Last Train Home",
    platform_id: "demo-ott-a",
    platform_name: "StreamEast India",
    status: "success",
    period_label: "Jan 2026 – Mar 2026",
    total_revenue: 42_800,
  },
  {
    project_id: "demo-live-1",
    project_title: "The Last Train Home",
    platform_id: "demo-ott-b",
    platform_name: "FictionFlix",
    status: "initiated",
    period_label: "Feb 2026 – Mar 2026",
    total_revenue: 18_400,
  },
  {
    project_id: "demo-live-2",
    project_title: "Monsoon Letters",
    platform_id: "demo-ott-a",
    platform_name: "StreamEast India",
    status: "pending",
    period_label: "Mar 2026 – Mar 2026",
    total_revenue: 9_650,
  },
  {
    project_id: "demo-live-2",
    project_title: "Monsoon Letters",
    platform_id: "demo-linear-1",
    platform_name: "Metro Movies TV",
    status: "success",
    period_label: "Jan 2026 – Feb 2026",
    total_revenue: 31_200,
  },
];
